/**
 * 계정 정보를 가지고 어떤 url로 바꿔야하는지 가져옴
 * @param {*} Auth
 */
export function routePathForAuth({ _id, status }) {
  if (_id !== undefined && _id !== null) {
    // 계정은 있는 상태
    if (!status) {
      // 계정 비활성화
      return '/';
    } else {
      // admin 계정
      if (_id === 'admin') {
        return '/cms';
      }
      return '/player';
    }
  }
  return '/';
}
export function siteMapForCwr(Auth, match, history) {
  const currentPath = match.path;
  let nextPath = null;
  // 이동해야할 패스가 어디인지 결정 player, cms, 로그인 페이지로 이동
  nextPath = routePathForAuth(Auth);
  if (currentPath !== nextPath) {
    if (nextPath === '/player') {
      history.replace(nextPath);
    } else if (nextPath === '/cms') {
      window.location.href = '/cms';
    } else {
      history.replace(nextPath);
    }
  }
}
export default { routePathForAuth, siteMapForCwr };
